import { styled } from '@mui/material';

import {
  Icons,
  SxProps,
  Tooltip,
  tokens,
  withProps,
  Box,
} from '@cast/design-system';

const ServiceAccountIconBase = styled(withProps(Icons.Nut, { weight: 'fill' }))(
  () => ({
    color: tokens.theme.fg.structural.secondary,
    background: 'transparent',
    borderRadius: '50%',
    border: `1px solid ${tokens.theme.fg.structural.secondary}`,
    padding: '4px',
    fontSize: 24,
    flexShrink: 0,
  })
);

type ServiceAccountIconProps = Icons.IconProps & {
  size?: number;
  sx?: SxProps;
};

export const ServiceAccountIcon = (props: ServiceAccountIconProps) => {
  return (
    <Tooltip title="Service account">
      <Box component="span" display="inline-flex">
        <ServiceAccountIconBase {...props} />
      </Box>
    </Tooltip>
  );
};
